import version from '../../../../package.json';

export const PERFORMANCE_SPANS = {
    NPI_DATA_GRID: {
        LOAD: 'NPIDataGrid:load',
        PAGINATION: 'NPIDataGrid:pagination',
        FILTER: 'NPIDataGrid:filter',
        SORT: 'NPIDataGrid:sort',
    },
} as const;

export const PERFORMANCE_CONFIG = {
    isEnabled: process.env.STAGE !== 'local',
    apiKey: process.env.FRONTEND_BUGSNAG_API_KEY,
    appVersion: version.version.toString(),
    releaseStage: process.env.STAGE,
    enabledReleaseStages: ['prod', 'uat', 'dev'],
};
